import * as PropTypes from "prop-types";
import React, {useEffect, useRef, useState} from "react";
import {Carousel, Spin} from "antd";
import {LeftOutlined, RightOutlined} from "@ant-design/icons";
import VehicleCard from "./VehicleCard";
import {getSessionData} from "../../utility/global-util";
import {useLocation} from "react-router-dom";


const SliderPanel = ({fade = false, loading, pageLoading = false, onSlideChange, readOnly, contractInfo = null, children}) => {
    const dummyVehicle = JSON.parse('{"regNo" : "", "status" : {"code" : "warn", "description" : "Loading"}}');

    const location = useLocation();

    // Carousel Control (ref passed in or declared above)
    const [theSlide, setTheSlide] = useState(0);
    const ref = useRef();
    const goTo = (slide, index) => {
        if(!readOnly && !pageLoading && index !== theSlide)
        {
            ref.current.goTo(slide, false);
        }
    };
    const onCarouselChange = (newSlide) => {
        if(!readOnly && !pageLoading)
        {
            setTheSlide(newSlide);
            if(onSlideChange)
            {
                onSlideChange(children[newSlide]);
            }
        }
    };
    const getSelected = (slideNo, disabled) => {
        if (slideNo === theSlide) {
            return (
                {
                    borderColor: 'var(--dp-primary-colour)',
                    backgroundColor: 'var(--dp-primary-colour)',
                    cursor: 'default',
                }
            );
        } else {
            return (
                {
                    cursor: (disabled ? 'default' : 'pointer'),
                }
            );
        }
    };

    // Detect contract change or page change to keep contract based slides accurate
    const currentContract = getSessionData('currentContract');
    const currentPath = location.pathname;
    useEffect(() => {
        if (contractInfo && contractInfo.length > 0 && currentContract && currentContract.contractNo) {
            const infoItem = contractInfo.find(info => info.contractNo === currentContract.contractNo);
            if (infoItem && ref && ref.current) {
                // Change slide
                setTheSlide(infoItem.slideNo);
                ref.current.goTo(infoItem.slideNo, true);
            }
        }
    }, [currentContract, contractInfo, currentPath]);

    // Dots underneath
    const CarouselDots = ({noOfDots, readOnly, disabled}) => {

        const [dotArray, setDotArray] = useState([]);

        useEffect(() => {
            setDotArray(Array(noOfDots).fill(''));
        }, [noOfDots]);

        let dotIndex = 0;

        return (
         loading
         ? (
            <div className="dp-carousel-dots" style={{ marginTop: '10px', marginBottom: '14px' }}>
                <Spin />
            </div>
           )
         : (
            (noOfDots > 1 && !readOnly)
            ?
            <div className="dp-carousel-dots">
                {
                    dotArray.map((item, i) => {
                            const loopIndex = dotIndex++;
                            return (<button key={i} className="dp-carousel-dot" onClick={() => goTo(i, loopIndex)} style={getSelected(loopIndex, disabled)} disabled={disabled}/>);
                        }
                    )
                }
            </div>
            :
            <></>)
           );
    }

    return (
        <div>
            { loading
            ?   <div className="dp-carousel_spacing">
                    <VehicleCard loading={true} contract={{ contractVehicle: dummyVehicle}}/>
                </div>
            :   <Carousel swipe={!readOnly} fade={fade} className="dp-carousel_spacing" ref={ref} afterChange={onCarouselChange} dots={false} arrows={!readOnly && children.length>1 && !pageLoading} prevArrow={<LeftOutlined />} nextArrow={<RightOutlined />}>
                    { children }
                </Carousel>}
            <CarouselDots noOfDots={children ? children.length : 1} readOnly={readOnly} disabled={pageLoading} />
        </div>
    );
}

// Validate prop type parameters.
SliderPanel.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element,
        PropTypes.arrayOf(PropTypes.element)]).isRequired,
    onSlideChange: PropTypes.func,
};

export default SliderPanel;